import { getHistoryDetailData } from '@/api/query';
import Type from '@/store/mutation-type';
import { isEmpty } from '@/utils/is';
import { socketModsFilter } from '@/utils/modsFilter';

export default {
  namespaced: 'history',
  state: {
    historyDetailData: {},
    historyDetailDatas: [],
    eventId: ''
  },
  mutations: {
    [Type.GET_HISTORY_DATA](state, data) {
      if (isEmpty(data)) return;

      socketModsFilter(data.deviceData.deviceType, data.deviceData);
      data.deviceDatas.forEach(e => socketModsFilter(data.deviceData.deviceType, e));

      state.historyDetailData = data.deviceData;
      state.historyDetailDatas.splice(0, Infinity, ...data.deviceDatas);
    },
    [Type.CLEAR_HISTORY_DATA](state) {
      state.historyDetailData = {};
      state.historyDetailDatas.splice(0, Infinity);
    }
  },
  actions: {
    async getHistoryDetailData({ state, commit }, eventId) {
      commit(Type.CLEAR_HISTORY_DATA);
      const res = await getHistoryDetailData(eventId);
      if (!res) return;
      state.eventId = eventId;
      commit(Type.GET_HISTORY_DATA, res.data);
      return res;
    }
  }
};
